import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";
import { exceptionHandler } from "../../pages/common/functions";

export default class DABFilmsService {
	public static dabFilmsSave(input: any) {
		return input?.id > 0
			? Http.axios()
					.put(`/api/Messages/update-dab-film-video/${input?.id}`, input?.dabFilmsInput, {
						headers: { Authorization: getUserAccessToken() },
					})
					.then((res: any) => {
						return res;
					})
					.catch((e: any) => {
						return e.response;
					})
			: Http.axios()
					.post("/api/Messages/upload-dab-film-video", input?.dabFilmsInput, {
						headers: { Authorization: getUserAccessToken() },
					})
					.then((res: any) => {
						return res;
					})
					.catch((e: any) => {
						return e.response;
					});
	}

	public static dabFilmsGetByFilter(input:any) {
		return Http.axios()
			.get(`/api/Messages/get-all-dab-films/${input.msgBoardID}` + `?searchText=${input?.searchText}&pageNumber=${input?.pageNumber}&pageSize=${input?.pageSize}`, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static dabFilmsGetDetail(id: any) {

		return Http.axios()
			.get("/api/Messages/get-dabfilm-byid/" + id, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static dabFilmsDelete(input: any) {
        return Http.axios().delete('/api/Messages/delete-dab-film/' + input, { headers: { 'Authorization': getUserAccessToken() } })
            .catch((e: { response: any; }) => {
                return e.response;
            }) as AxiosPromise<any>;
    }

	public static dabFilmsVideoStatusUpdate(input: any) {
        return Http.axios().post('/api/Messages/update-message-video-active', input, { headers: { 'Authorization': getUserAccessToken() } })
            .then((res: any) => {return res; })
            .catch((e: any) => { return e.response; }) as AxiosPromise<any>;
	}

	public static dabFilmsGenerateSASToken() {
		return (
			Http.axios()
				.get("/api/Messages/generate-dabfilms-sas-token", {
					headers: { Authorization: getUserAccessToken() },
				})
				.then((res: any) => {
					var response = exceptionHandler(res);
					return response?.data;
				})
				.catch((e: { response: any }) => {
					return e.response;
				}) as AxiosPromise<any>
		);
	}
}
